import { render, staticRenderFns } from "./update-grouping-package.vue?vue&type=template&id=5e6b3a86&"
import script from "./update-grouping-package.vue?vue&type=script&lang=ts&"
export * from "./update-grouping-package.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports